module.exports = __webpack_public_path__ + "static/media/icon5.b7b2e117.svg";